<wr-new-data-table headerText="Labelübersicht"
                   localStorageIdentifier="label-overview"
                   [loadItemsFunction]="loadLabels"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToLabel($event)"
                   (newClick)="add()"
                   [form]="form"
                   [isAdmin]="canCreate()">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-items">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-label
    key="shortcut"
    display="Kürzel">
    <div *ngIf="label.shortcut">
      {{label.shortcut}}
    </div>
  </ng-template>
  <ng-template
    dataColumn
    let-label
    key="name"
    display="Name">
    <div *ngIf="label.name">
      {{label.name}}
    </div>
  </ng-template>
  <ng-template
    dataColumn
    let-label
    key="color"
    display="Farbe">
    <div class="color-swatch" [style.background]="label.color"></div>
  </ng-template>
  <ng-template
    dataColumn
    let-label
    key="dimension"
    display="Dimension">
    <div *ngIf="label.dimension">
      {{label.dimension | dimensionTranslation}}
    </div>
  </ng-template>
  <ng-template
    dataColumn
    let-label
    key="isVisible"
    display="Sichtbar">
    {{label.isVisible ? 'Ja' : 'Nein'}}
  </ng-template>
</wr-new-data-table>

